import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';

/**
 * Wraps page content with Framer Motion page transitions.
 *
 * Uses AnimatePresence with mode="wait" so the previous page animates out
 * before the next one animates in. The motion.div is keyed to the current
 * pathname so React Router route changes trigger the transition.
 *
 * Transition: fade + subtle vertical slide (0.4s).
 * Gracefully degrades via Framer Motion's built-in reduced-motion handling.
 */
const variants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10 },
};

const transition = {
  duration: 0.4,
  ease: [0.22, 1, 0.36, 1], // custom ease-out for a premium feel
};

const PageTransition = ({ children }) => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        initial="initial"
        animate="animate"
        exit="exit"
        variants={variants}
        transition={transition}
        style={{ willChange: 'opacity, transform' }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default PageTransition;
